import { Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ReplaySubject, forkJoin } from 'rxjs';
import { debounceTime, last, map, switchMap, tap } from 'rxjs/operators';
import { SnackBarItem } from 'src/app/shared/global_components/snack-bar/snack-bar-item';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { CompanyService } from 'src/app/shared/services/rest/company.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-field',
  templateUrl: './change-field.component.html',
  styleUrls: ['./change-field.component.scss']
})
export class ChangeFieldComponent extends BaseClass implements OnInit, OnDestroy {
  public host: any = environment.host;
  
  public statuses$: ReplaySubject<any> = new ReplaySubject<any>(1);
  public statusesMoreControl: FormControl = new FormControl();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChangeFieldComponent>,
    private fb: FormBuilder,
    private companyService: CompanyService,
    private layoutService: LayoutService
  ) { super() }

  ngOnInit(): void {
    console.log("ChangeFieldComponent", this.data)
    this.statuses$.next(this.data.statuses.slice());

    this.attachSubscriptions(
      this.statusesMoreControl.valueChanges.pipe(debounceTime(300)).subscribe((resp) => this.onSearchStatuses(resp))
    )

    this.attachSubscriptions(
      this.data.form.valueChanges.subscribe((res) => {
        this.dialogRef.close({event: "close", data: false})
      })
    )
  }

  onSearchStatuses(resp) {
    if (!this.data.statuses) {
      return;
    }

    if (!resp) {
      this.statuses$.next(this.data.statuses.slice());
      return;
    } else {
      resp = resp.toLowerCase();
    }
    // filter the banks
    this.statuses$.next(
      this.data.statuses.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
    );
  }

  close() {
    this.dialogRef.close({event: "close", data: false})
  }

  ngOnDestroy(): void {
    this.clearSubscriptions()
  }
}
